import * as React from 'react';

import ClientClientsCreateForm from "./create/client_clients_create_form";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import Progress from "../../../common/organism/progress";
import {TBreadcrumbItem} from "../../../type/common";
import {routeConfig} from "../../../../config/language/ja-JP/presentation/route_text";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";

interface IProps {
    isLoading: boolean;
    handleCreateSubmit: (values: any) => void;
}

const ClientClientsCreateComponent: React.FC<IProps> = (props) => {
    const { isLoading, handleCreateSubmit } = props;

    const breadcrumbItems: TBreadcrumbItem[] = [
        routeConfig.clientRoot,
        routeConfig.clientMypageCompanyInfo,
        routeConfig.clientClientsCreate
    ]

    return (
        <React.Fragment>

            {isLoading && <Progress canAnimation={false}/>}

            <PageWrapper>
                <Breadcrumbs breadcrumbItems={breadcrumbItems} />

                <ClientClientsCreateForm
                    // For Redux-Form
                    onSubmit={handleCreateSubmit}
                />

            </PageWrapper>

        </React.Fragment>
    )

};

export default ClientClientsCreateComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/client/clients/client_clients_create.tsx